<script lang="ts">
  import { onMount } from "svelte";
  import { pop } from "svelte-spa-router";

  export let params;

  onMount(() => {
    if (import.meta.env.DEV) {
      console.log("NotFound mounted. params: " + JSON.stringify(params));
    }
  });
</script>

<div class="flex w-full flex-col justify-center">
  <div class="px-[16px] pt-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
  </div>
  <div class="text-center pb-[48px] w-full">
    <img
      alt={"404-not-found"}
      class="py-4 m-5 mx-auto"
      src="/graphics/not-found.svg"
    />
    <h2 class="text-[#58686A] text-medium">
      Opps! Här blir det tufft att parkera
    </h2>
    <p class="text-[#58686A] text-medium pt-[16px]">
      Det ser ut som att sidan du letar efter inte existerar
    </p>
  </div>
</div>
